const messages = {
  es: {
    languageSwitcher: {
      label: "Idioma",
      es: "ES",
      en: "EN",
    },
    nav: {
      home: "Inicio",
      about: "Sobre nosotros",
      contact: "Cont\u00e1ctanos",
    },
    hero: {
      titlePrefix: "L\u00edderes en",
      typedWords: ["construcci\u00f3n", "energ\u00eda", "calidad"],
      description:
        "Transformamos el futuro con soluciones sostenibles en construcci\u00f3n y energ\u00eda, impulsando el desarrollo con innovaci\u00f3n y calidad.",
      primaryAction: "Cont\u00e1ctanos",
      secondaryAction: "Con\u00f3cenos",
    },
    counters: [
      {
        count: 100,
        suffix: "+",
        title: "Proyectos completados",
        description:
          "Hemos entregado obras de construcci\u00f3n y energ\u00eda que cumplen con altos est\u00e1ndares de calidad.",
      },
      {
        count: 50,
        suffix: "+",
        title: "Clientes satisfechos",
        description:
          "Empresas y particulares que conf\u00edan en nosotros para sus proyectos de infraestructura y energ\u00eda.",
      },
      {
        count: 10,
        title: "A\u00f1os de experiencia",
        description:
          "M\u00e1s de una d\u00e9cada brindando soluciones innovadoras y sostenibles en distintos sectores.",
      },
    ],
    information: {
      frontTitleTop: "Construyendo el",
      frontTitleBottom: "Futuro",
      frontDescription:
        "Innovamos en construcci\u00f3n y energ\u00eda sostenible para un futuro m\u00e1s eficiente y responsable.",
      backTitle: "Con\u00f3cenos",
      backDescription:
        "Ofrecemos soluciones integrales en infraestructura y energ\u00eda, combinando calidad e innovaci\u00f3n para impulsar el desarrollo.",
      backAction: "Descubre m\u00e1s",
      cards: [
        {
          icon: "engineering",
          title: "Construcci\u00f3n eficiente",
          description:
            "Creamos infraestructura innovadora con altos est\u00e1ndares de calidad y sostenibilidad.",
        },
        {
          icon: "bolt",
          title: "Energ\u00eda sostenible",
          description: "Impulsamos el futuro con soluciones energ\u00e9ticas limpias y eficientes.",
        },
        {
          icon: "attach_money",
          title: "Optimizaci\u00f3n de recursos",
          description: "Maximizamos el valor de cada proyecto con eficiencia y responsabilidad.",
        },
        {
          icon: "devices",
          title: "Innovaci\u00f3n tecnol\u00f3gica",
          description:
            "Aplicamos tecnolog\u00eda avanzada para garantizar soluciones seguras y de alto rendimiento.",
        },
      ],
    },
    pages: {
      badge: "servicios especializados",
      title: "Soluciones integrales en construcci\u00f3n y energ\u00eda",
      description:
        "Desde proyectos habitacionales hasta infraestructura energ\u00e9tica, ofrecemos servicios confiables, eficientes y sostenibles.",
      asideTitle: "Conf\u00eda en nuestra experiencia",
      asideDescription:
        "Hemos trabajado en proyectos de alto impacto, combinando tecnolog\u00eda, calidad y compromiso para transformar espacios y energ\u00edas.",
      items: [
        { name: "Construcci\u00f3n", route: "/construccion" },
        { name: "Energ\u00eda", route: "/pages/landing-pages/contact-us" },
        { name: "Sobre nosotros", route: "/construccion" },
        { name: "Contacto", route: "/pages/landing-pages/contact-us" },
      ],
    },
    testimonials: {
      titleLead: "Con la confianza de m\u00e1s de",
      titleHighlight: "100 empresas y familias",
      description:
        "Desde desarrollos habitacionales hasta proyectos energ\u00e9ticos, nuestros clientes respaldan nuestro compromiso con la calidad y la innovaci\u00f3n.",
      reviews: [
        {
          name: "Antonio Salcido",
          date: "Hace 1 d\u00eda",
          review:
            "El equipo super\u00f3 nuestras expectativas. Entregaron la obra en tiempo y con excelente calidad. 100% recomendados.",
          rating: 5,
        },
        {
          name: "Diego Osorio",
          date: "Hace 6 d\u00edas",
          review:
            "Nos ayudaron a implementar un sistema solar para nuestra empresa. Muy profesionales y atentos en todo momento.",
          rating: 5,
        },
        {
          name: "Fernando Moreno",
          date: "Hace 3 semanas",
          review:
            "Contratamos sus servicios para una remodelaci\u00f3n y quedamos encantados. Buen trato, buenos tiempos y materiales de primera.",
          rating: 5,
        },
      ],
    },
    constructionPage: {
      hero: {
        eyebrow: "Construcci\u00f3n",
        title: "Ejecutamos obras que combinan planeaci\u00f3n, calidad y cumplimiento.",
        description:
          "Desarrollamos proyectos residenciales, comerciales e industriales con control t\u00e9cnico, supervisi\u00f3n constante y una ejecuci\u00f3n ordenada de principio a fin.",
        primaryAction: "Solicitar cotizaci\u00f3n",
        secondaryAction: "Ir a contacto",
      },
      services: {
        title: "Servicios de construcci\u00f3n",
        description:
          "Acompa\u00f1amos cada etapa de la obra con equipos coordinados, metodolog\u00edas claras y atenci\u00f3n al detalle.",
        cards: [
          {
            icon: "foundation",
            title: "Obra civil",
            description:
              "Cimentaciones, estructura, alba\u00f1iler\u00eda y adecuaciones ejecutadas con enfoque t\u00e9cnico y operativo.",
          },
          {
            icon: "architecture",
            title: "Remodelaci\u00f3n y ampliaci\u00f3n",
            description:
              "Intervenimos espacios existentes para modernizarlos, ampliar capacidad y mejorar funcionalidad.",
          },
          {
            icon: "inventory_2",
            title: "Acabados y entregas",
            description:
              "Cuidamos los detalles finales para lograr espacios listos para operar, habitar o comercializar.",
          },
          {
            icon: "fact_check",
            title: "Supervisi\u00f3n de obra",
            description:
              "Seguimiento de avance, control de calidad, coordinaci\u00f3n de contratistas y cumplimiento de programa.",
          },
        ],
        featuredTitle: "Construimos con procesos claros",
        featuredDescription:
          "Priorizamos seguridad, tiempos y visibilidad del avance para que cada proyecto tenga una ejecuci\u00f3n confiable y medible.",
        featuredAction: "Ver contacto",
      },
      process: {
        title: "Nuestro proceso",
        description:
          "Convertimos el alcance del proyecto en una ruta de trabajo clara, con definiciones t\u00e9cnicas y seguimiento continuo.",
        steps: [
          {
            name: "Diagn\u00f3stico inicial",
            label: "Planeaci\u00f3n",
            description:
              "Revisamos necesidades, condiciones del sitio, alcances, presupuesto objetivo y prioridades del cliente.",
          },
          {
            name: "Programa y coordinaci\u00f3n",
            label: "Preparaci\u00f3n",
            description:
              "Definimos frentes de trabajo, secuencia constructiva, suministros y tiempos de ejecuci\u00f3n.",
          },
          {
            name: "Ejecuci\u00f3n en campo",
            label: "Construcci\u00f3n",
            description:
              "Desarrollamos la obra con supervisi\u00f3n constante, control de calidad y comunicaci\u00f3n puntual.",
          },
          {
            name: "Cierre y entrega",
            label: "Resultado",
            description:
              "Validamos acabados, detalles pendientes y condiciones finales para una entrega ordenada.",
          },
        ],
      },
      stats: {
        title: "Capacidad de ejecuci\u00f3n",
        description:
          "Trabajamos con una combinaci\u00f3n de experiencia operativa, disciplina de obra y enfoque en resultados.",
        counters: [
          {
            count: 100,
            suffix: "+",
            title: "Frentes atendidos",
            description:
              "Participaci\u00f3n en proyectos de construcci\u00f3n, mantenimiento, adecuaci\u00f3n y mejora de espacios.",
          },
          {
            count: 10,
            suffix: "+",
            title: "A\u00f1os de experiencia",
            description:
              "Trayectoria acumulada en coordinaci\u00f3n de obra, log\u00edstica, calidad y cumplimiento.",
          },
          {
            count: 24,
            suffix: "/7",
            title: "Seguimiento",
            description:
              "Respuesta constante para dar visibilidad al avance, resolver incidencias y mantener ritmo de ejecuci\u00f3n.",
          },
        ],
      },
      cta: {
        title: "Llevemos tu proyecto a obra",
        description:
          "Si ya tienes una idea, planos o un sitio por desarrollar, podemos ayudarte a convertirlo en un proyecto ejecutable.",
        action: "Hablar con nosotros",
      },
    },
    footer: {
      menus: [
        {
          name: "empresa",
          items: [
            { name: "Inicio", route: "/" },
            { name: "Sobre nosotros", route: "/construccion" },
            { name: "Contacto", route: "/pages/landing-pages/contact-us" },
          ],
        },
        {
          name: "servicios",
          items: [
            { name: "Construcci\u00f3n", route: "/construccion" },
            { name: "Energ\u00eda", route: "/pages/landing-pages/contact-us" },
          ],
        },
        {
          name: "legal",
          items: [
            { name: "Privacidad", href: "#" },
            { name: "T\u00e9rminos", href: "#" },
          ],
        },
      ],
      copyrightLead: "Todos los derechos reservados. Copyright",
      by: "por",
    },
  },
  en: {
    languageSwitcher: {
      label: "Language",
      es: "ES",
      en: "EN",
    },
    nav: {
      home: "Home",
      about: "About us",
      contact: "Contact us",
    },
    hero: {
      titlePrefix: "Leaders in",
      typedWords: ["construction", "energy", "quality"],
      description:
        "We shape the future with sustainable construction and energy solutions, driving development through innovation and quality.",
      primaryAction: "Contact us",
      secondaryAction: "Learn more",
    },
    counters: [
      {
        count: 100,
        suffix: "+",
        title: "Completed projects",
        description:
          "We have delivered construction and energy projects that meet high quality standards.",
      },
      {
        count: 50,
        suffix: "+",
        title: "Satisfied clients",
        description:
          "Companies and families trust us with their infrastructure and energy projects.",
      },
      {
        count: 10,
        title: "Years of experience",
        description:
          "More than a decade delivering innovative and sustainable solutions across sectors.",
      },
    ],
    information: {
      frontTitleTop: "Building the",
      frontTitleBottom: "Future",
      frontDescription:
        "We innovate in construction and sustainable energy for a more efficient and responsible future.",
      backTitle: "Get to know us",
      backDescription:
        "We provide comprehensive infrastructure and energy solutions, combining quality and innovation to drive progress.",
      backAction: "Discover more",
      cards: [
        {
          icon: "engineering",
          title: "Efficient construction",
          description:
            "We create innovative infrastructure with high standards of quality and sustainability.",
        },
        {
          icon: "bolt",
          title: "Sustainable energy",
          description: "We power the future with clean and efficient energy solutions.",
        },
        {
          icon: "attach_money",
          title: "Resource optimization",
          description: "We maximize the value of every project with efficiency and accountability.",
        },
        {
          icon: "devices",
          title: "Technological innovation",
          description: "We apply advanced technology to deliver safe, high-performance solutions.",
        },
      ],
    },
    pages: {
      badge: "specialized services",
      title: "Integrated construction and energy solutions",
      description:
        "From housing developments to energy infrastructure, we deliver reliable, efficient, and sustainable services.",
      asideTitle: "Trust our experience",
      asideDescription:
        "We have worked on high-impact projects, combining technology, quality, and commitment to transform spaces and energy systems.",
      items: [
        { name: "Construction", route: "/construccion" },
        { name: "Energy", route: "/pages/landing-pages/contact-us" },
        { name: "About us", route: "/construccion" },
        { name: "Contact", route: "/pages/landing-pages/contact-us" },
      ],
    },
    testimonials: {
      titleLead: "Trusted by more than",
      titleHighlight: "100 companies and families",
      description:
        "From residential developments to energy projects, our clients back our commitment to quality and innovation.",
      reviews: [
        {
          name: "Antonio Salcido",
          date: "1 day ago",
          review:
            "The team exceeded our expectations. They delivered the project on time and with outstanding quality. Highly recommended.",
          rating: 5,
        },
        {
          name: "Diego Osorio",
          date: "6 days ago",
          review:
            "They helped us implement a solar system for our company. Very professional and attentive throughout the whole process.",
          rating: 5,
        },
        {
          name: "Fernando Moreno",
          date: "3 weeks ago",
          review:
            "We hired them for a renovation project and were delighted. Great service, solid timelines, and top-quality materials.",
          rating: 5,
        },
      ],
    },
    constructionPage: {
      hero: {
        eyebrow: "Construction",
        title: "We deliver projects with planning, quality, and reliable execution.",
        description:
          "We develop residential, commercial, and industrial projects with technical control, constant supervision, and disciplined execution from start to finish.",
        primaryAction: "Request a quote",
        secondaryAction: "Go to contact",
      },
      services: {
        title: "Construction services",
        description:
          "We support every stage of the build with coordinated teams, clear methods, and attention to detail.",
        cards: [
          {
            icon: "foundation",
            title: "Civil works",
            description:
              "Foundations, structure, masonry, and site adaptations delivered with technical and operational focus.",
          },
          {
            icon: "architecture",
            title: "Renovation and expansion",
            description:
              "We upgrade and expand existing spaces to improve capacity, function, and long-term value.",
          },
          {
            icon: "inventory_2",
            title: "Finishes and handover",
            description:
              "We take care of final details so spaces are ready to operate, live in, or commercialize.",
          },
          {
            icon: "fact_check",
            title: "Site supervision",
            description:
              "Progress tracking, quality control, contractor coordination, and schedule compliance.",
          },
        ],
        featuredTitle: "We build with clear processes",
        featuredDescription:
          "We prioritize safety, timing, and progress visibility so every project moves forward with confidence.",
        featuredAction: "View contact",
      },
      process: {
        title: "Our process",
        description:
          "We turn project scope into a clear work plan with technical definitions and continuous follow-up.",
        steps: [
          {
            name: "Initial assessment",
            label: "Planning",
            description:
              "We review needs, site conditions, project scope, target budget, and client priorities.",
          },
          {
            name: "Schedule and coordination",
            label: "Preparation",
            description:
              "We define work fronts, construction sequence, supplies, and execution timing.",
          },
          {
            name: "Field execution",
            label: "Construction",
            description:
              "We carry out the project with constant supervision, quality control, and timely communication.",
          },
          {
            name: "Closing and delivery",
            label: "Outcome",
            description:
              "We validate finishes, pending details, and final conditions for an orderly handover.",
          },
        ],
      },
      stats: {
        title: "Execution capacity",
        description:
          "We work with a combination of operational experience, site discipline, and results-driven management.",
        counters: [
          {
            count: 100,
            suffix: "+",
            title: "Projects supported",
            description:
              "Participation in construction, maintenance, adaptation, and space improvement projects.",
          },
          {
            count: 10,
            suffix: "+",
            title: "Years of experience",
            description:
              "Accumulated experience in site coordination, logistics, quality, and delivery compliance.",
          },
          {
            count: 24,
            suffix: "/7",
            title: "Project follow-up",
            description:
              "Consistent response to track progress, solve issues, and keep execution moving.",
          },
        ],
      },
      cta: {
        title: "Let\u2019s take your project into execution",
        description:
          "If you already have an idea, plans, or a site to develop, we can help turn it into an executable project.",
        action: "Talk to us",
      },
    },
    footer: {
      menus: [
        {
          name: "company",
          items: [
            { name: "Home", route: "/" },
            { name: "About us", route: "/construccion" },
            { name: "Contact", route: "/pages/landing-pages/contact-us" },
          ],
        },
        {
          name: "services",
          items: [
            { name: "Construction", route: "/construccion" },
            { name: "Energy", route: "/pages/landing-pages/contact-us" },
          ],
        },
        {
          name: "legal",
          items: [
            { name: "Privacy", href: "#" },
            { name: "Terms", href: "#" },
          ],
        },
      ],
      copyrightLead: "All rights reserved. Copyright",
      by: "by",
    },
  },
};

export default messages;
